import FacebookSdk from "~/plugins/facebook.js";
import LongLivedUserAccessTokenQuery from "~/graphql/facebook/long-lived-user-access-token.gql";
import SaveAccountMutation from "~/graphql/facebook/accounts/save.gql";

const SCOPE =
    "public_profile,email,pages_manage_ads,leads_retrieval,pages_read_engagement,pages_manage_metadata,pages_show_list,ads_management";

/**
 * FB.login (+ rerequest) → long-lived token → saveFacebookAccount.
 * @param {object} apollo - this.$apollo
 * @param {{ rerequest?: boolean }} [options]
 * @returns {Promise<object>} facebookAccount salvo
 */
export async function connectFacebookAccount(apollo, { rerequest = true } = {}) {
    const FB = await FacebookSdk;

    const loginOptions = { scope: SCOPE };
    if (rerequest) {
        loginOptions.auth_type = "rerequest";
    }

    let { status, authResponse } = await new Promise((resolve) => {
        FB.login(resolve, loginOptions);
    });
    if (status !== "connected") {
        throw new Error("Facebook not connected");
    }

    let { accessToken, userID: userId } = authResponse;
    let profile = await new Promise((resolve) => {
        FB.api(
            "/me",
            {
                fields: "id,name,picture,email",
            },
            resolve
        );
    });

    let {
        data: {
            facebookLongLivedUserAccessToken: { access_token },
        },
        errors,
    } = await apollo.query({
        query: LongLivedUserAccessTokenQuery,
        variables: {
            access_token: accessToken,
        },
    });

    if (errors) {
        let [error] = errors;
        throw error;
    }

    let { data: picture } = profile.picture;
    let { email, name } = profile;

    let {
        data: {
            saveFacebookAccount: { facebookAccount },
        },
    } = await apollo.mutate({
        mutation: SaveAccountMutation,
        variables: {
            facebookAccount: {
                userId,
                name,
                email,
                picture,
                access_token,
            },
        },
    });

    let { status: sessionStatus } = await new Promise((resolve) => {
        FB.getLoginStatus(resolve);
    });
    if (sessionStatus === "connected") {
        await new Promise((resolve) => {
            FB.logout(resolve);
        });
    }

    return facebookAccount;
}
